'use client';

import { useTranslations } from 'next-intl';
import { Wallet, Languages, AlarmClock, Receipt } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import FadeInSection from '@/components/ui/FadeInSection';
import { StageMarker } from '@/components/layout/StoryRail';

export default function GuaranteesSection() {
  const t = useTranslations('guarantees');

  const items: { Icon: LucideIcon; title: string; desc: string }[] = [
    { Icon: Wallet, title: t('item1Title'), desc: t('item1Desc') },
    { Icon: Languages, title: t('item2Title'), desc: t('item2Desc') },
    { Icon: AlarmClock, title: t('item3Title'), desc: t('item3Desc') },
    { Icon: Receipt, title: t('item4Title'), desc: t('item4Desc') },
  ];

  return (
    <section
      id="gwarancje"
      className="relative scroll-mt-2 border-t border-surface-bright/15 px-margin-mobile py-section-gap lg:scroll-mt-4 lg:px-margin-desktop"
    >
      <StageMarker n={3} />
      <div className="mx-auto w-full max-w-6xl">
        <FadeInSection direction="right" distance={64}>
          <p className="text-label-caps uppercase tracking-widest text-primary">{t('eyebrow')}</p>
          <h2 className="mt-stack-md max-w-3xl font-headline text-headline-lg font-bold tracking-[0.02em] text-on-surface">
            {t('headline')}
          </h2>
        </FadeInSection>

        <ul className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {items.map(({ Icon, title, desc }, i) => (
            <li key={title} className="forest-card">
              <FadeInSection delay={i * 0.08} className="h-full">
                <div className="flex h-full flex-col gap-stack-lg p-8 lg:p-10">
                  <Icon
                    width={36}
                    height={36}
                    strokeWidth={1.5}
                    aria-hidden="true"
                    className="text-primary"
                  />
                  <div>
                    <h3 className="font-headline text-headline-md font-bold text-on-surface">
                      {title}
                    </h3>
                    <p className="mt-stack-md text-body-md text-on-surface-variant md:text-body-lg">
                      {desc}
                    </p>
                  </div>
                </div>
              </FadeInSection>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
